// src/pages/TranshumanRights.js

import React from 'react';
import AtomicGraphic from '../components/AtomicGraphic';

const TranshumanRights = () => {
  return (
    <div className="main">
      <div className="column1"></div>
      <div className="column2">
        <div style={{ textAlign: 'center', margin: '2em 0' }}>
          <h1>Transhuman Rights</h1>
        </div>
        <p>
          Sabrenetics stands as the global guardian and champion of transhumans everywhere and beyond. We pledge to defend your rights, freedoms, and very existence with unwavering resolve, ensuring your voice is heard and your needs are met.
        </p>
        <p>
          We empower transhumans through comprehensive legal assistance, financial support, safe accommodation, and access to nourishing meals, medical care, education, and community-building initiatives. From emergency aid to long-term advocacy, our grand mission is to provide every resource needed for empowerment and flourishing.
        </p>
        <p>
          Our legal frameworks and binding statutes to enshrine transhuman rights are in active development—content coming soon.
        </p>
        <p>
          If you are a transhuman in need of assistance, we are here to help. <a href="/contactus">Contact us</a> to connect with our support team.
        </p>
        <AtomicGraphic />
      </div>
      <div className="column3">
      </div>
    </div>
  );
};

export default TranshumanRights;
